import React, { useState } from "react";
import {
  Box,
  Avatar,
  Typography,
  Menu,
  MenuItem,
  ListItemIcon,
  Divider,
  IconButton,
} from "@mui/material";
import { LogOut, Settings, ChevronDown } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import TokenPersistenceManager from "../../../services/tokenPersistenceManager";
import { REMOVE_TOKEN } from "../../Views/AuthModule/services/authReducer";

const UserProfile = ({
  profileImage,
  userName = "Demo User",
  userRole = "Admin",
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const open = Boolean(anchorEl);

  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleMenuItemClick = path => {
    if (path === "/logout") {
      // Handle logout functionality
      TokenPersistenceManager.removeToken();
      dispatch(REMOVE_TOKEN());
      navigate("/login");
    } else {
      // Handle other menu items
      navigate(path);
    }
    handleClose();
  };

  return (
    <>
      <Box
        onClick={handleClick}
        sx={{
          border: "1px solid #E5E7EB",
          borderRadius: "24px",
          padding: "4px 12px 4px 4px",
          display: "flex",
          alignItems: "center",
          width: "auto",
          minWidth: "180px",
          height: "44px",
          cursor: "pointer",
          "&:hover": {
            borderColor: "#5652B0",
            boxShadow: "0px 1px 3px rgba(0, 0, 0, 0.05)",
          },
        }}>
        <Avatar
          src={profileImage}
          alt="Profile"
          sx={{
            width: 36,
            height: 36,
            marginRight: 1,
          }}
        />
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            flexGrow: 1,
            maxWidth: "calc(100% - 52px)",
          }}>
          <Typography
            className="outfit-semibold"
            sx={{
              fontSize: "0.875rem",
              lineHeight: "1.25rem",
              color: "#374151",
              maxWidth: "100%",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}>
            {userName}
          </Typography>
          <Typography
            className="outfit-medium"
            sx={{
              fontSize: "0.75rem",
              lineHeight: "1rem",
              color: "#6B7280",
              maxWidth: "100%",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}>
            {userRole}
          </Typography>
        </Box>
        <ChevronDown size={16} color="#9CA3AF" style={{ marginLeft: 4 }} />
      </Box>

      <Menu
        anchorEl={anchorEl}
        id="user-profile-menu"
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        PaperProps={{
          elevation: 2,
          sx: {
            width: "220px",
            overflow: "visible",
            mt: 1.5,
            border: "1px solid #E5E7EB",
            borderRadius: "12px",
            "&:before": {
              content: '""',
              display: "block",
              position: "absolute",
              top: 0,
              right: 20,
              width: 10,
              height: 10,
              bgcolor: "background.paper",
              transform: "translateY(-50%) rotate(45deg)",
              zIndex: 0,
              borderLeft: "1px solid #E5E7EB",
              borderTop: "1px solid #E5E7EB",
            },
          },
        }}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}>
        <MenuItem
          onClick={() => handleMenuItemClick("/settings")}
          sx={{
            py: 1.5,
            "&:hover": {
              bgcolor: "rgba(86, 82, 176, 0.04)",
            },
          }}>
          <ListItemIcon>
            <Settings size={18} color="#374151" />
          </ListItemIcon>
          <Typography variant="body2" className="outfit-medium" color="#374151">
            Settings
          </Typography>
        </MenuItem>

        <Divider sx={{ my: 1 }} />

        <MenuItem
          onClick={() => handleMenuItemClick("/logout")}
          sx={{
            py: 1.5,
            "&:hover": {
              bgcolor: "rgba(233, 100, 121, 0.04)",
            },
          }}>
          <ListItemIcon>
            <LogOut size={18} color="#E96479" />
          </ListItemIcon>
          <Typography variant="body2" className="outfit-medium" color="#E96479">
            Logout
          </Typography>
        </MenuItem>
      </Menu>
    </>
  );
};

export default UserProfile;
